export const rootElementStyles = {
  display: "inline-block",
};
